import React, { useEffect } from "react";
import l from "../styles.module.css";
import { Link } from "react-router-dom";
import video from "../assets/videoBK.mp4";

export default function Landing() {
  const [showElement, setShowElement] = React.useState(true);
  useEffect(() => {
    setTimeout(function () {
      setShowElement(false);
    }, 9000);
  }, []);

  return (
    <div className={l.container}>
      <video className={l.videoTag} autoPlay loop muted>
        <source src={video} type="video/mp4" />
      </video>
      <div className={l.centerHW}>
        {showElement ? (
          <div></div>
        ) : (
          <div>
            <Link to="/home" className={l.btn01}>
              ENTER
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
